export const NUKE_NEW_INVOICE_STATE = 'NUKE_NEW_INVOICE_STATE';

export const SUBMIT_DRAFT_INVOICE_REQUEST_LOADING =
  'SUBMIT_DRAFT_INVOICE_REQUEST_LOADING';
export const SUBMIT_DRAFT_INVOICE_REQUEST_FAILURE =
  'SUBMIT_DRAFT_INVOICE_REQUEST_FAILURE';
export const SUBMIT_DRAFT_INVOICE_REQUEST_SUCCESS =
  'SUBMIT_DRAFT_INVOICE_REQUEST_SUCCESS';
